// for add employee
export const RESER_ADD_CUSTOMER = "reset_add_customer";
export const ADD_CUSTOMER = "add_customer";
export const ADD_CUSTOMER_SUCCESS = "add_customer_success";
export const ADD_CUSTOMER_FAILURE = "add_customer_failure";
export const ADD_GOOGLE_CUSTOMER = "add_google_customer";
export const ADD_GOOGLE_CUSTOMER_SUCCESS = "add_google_customer_success";
export const ADD_GOOGLE_CUSTOMER_FAILURE = "add_google_customer_failure";
